// extracted by mini-css-extract-plugin
export default {"section":"inventory_section__OzTay","article":"inventory_article__wBwyn","content":"inventory_content__8Z3Pa","imgbox":"inventory_imgbox__rry5p","imgbox1":"inventory_imgbox1__5Xkur"};